import React from 'react'
import { authRoles } from '../../auth/authRoles'

const HotelRegRoute = [

    // {
    //     path: '/hotelregistration',
    //     component: React.lazy(() => import('./../HotelRegistration/HotelRegistration')),
    //     auth: authRoles.dashboard,
    // },

    {
        path: '/hotellist',
        component: React.lazy(() => import('./HotelList_Agoda')),  // need to replace HotelList, here  HotelList_agoda mean new search page using agoda
        auth: authRoles.dashboard,
    },

  

    {
        path: 'HotelRegistration/hotelrooms',
        component: React.lazy(() => import('./HotelRooms')),
        //auth: authRoles.dashboard,
    },

    {
        path: 'HotelRegistration/maincontact',
        component: React.lazy(() => import('./MainContacts')),
        //auth: authRoles.dashboard,
    },
    {
        path: 'HotelRegistration/payment',
        component: React.lazy(() => import('./Payment')),
        //auth: authRoles.dashboard,
    },

    {
        path: '/hotels/:id',
        component: React.lazy(() => import('./Hotels')),
        //auth: authRoles.dashboard,
    },

    {
        path: '/hotelroomSingle/:id',
        component: React.lazy(() => import('./HotelRoomSingle')),
        //auth: authRoles.dashboard,
    },
    {
        path: '/hotelroomHome',
        component: React.lazy(() => import('./RoomCard')),
        //auth: authRoles.dashboard,
    },

    // {
    //     path: '/singlehotel',
    //     component: React.lazy(() => import('./SingleHotel')),
    //     //auth: authRoles.dashboard,
    // },
  
]

export default HotelRegRoute
